import axios from '@/utils/http';

export default ({
  questionnaire,
  status = '',
  // name = '',
  // phone = '',
  // email = '',
  // emergency = '',
  // emergency_number = '',
  // emergency_relationship = '',
}) => {
  return axios
    .post('/landun', {
      questionnaire,
      status,
      // name,
      // phone,
      // email,
      // emergency,
      // emergency_number,
      // emergency_relationship,
    })
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};
